import { map, type Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { type ApiEnvelope, unwrapApiEnvelope } from '@core/models/api-envelope';
import { type PlatformAuthChangePasswordRequest, type PlatformAuthLoginRequest, type PlatformAuthSuccessDataDto } from '@core/models/platform-auth.dto';

@Injectable({ providedIn: 'root' })
export class PlatformAuthApiService {
  private readonly http = inject(HttpClient);

  changePassword(body: PlatformAuthChangePasswordRequest): Observable<void> {
    return this.http
      .post<ApiEnvelope<Record<string, never> | null>>('/api/auth/change-password', body)
      .pipe(map(() => void 0));
  }

  login(body: PlatformAuthLoginRequest): Observable<PlatformAuthSuccessDataDto> {
    return this.http
      .post<ApiEnvelope<PlatformAuthSuccessDataDto>>('/api/auth/login', body)
      .pipe(map((envelope) => unwrapApiEnvelope(envelope)));
  }

  logout(refreshToken: string | null): Observable<void> {
    return this.http
      .post<ApiEnvelope<Record<string, never> | null>>('/api/auth/logout', { refreshToken: refreshToken ?? '' })
      .pipe(map(() => void 0));
  }

  refresh(refreshToken: string): Observable<PlatformAuthSuccessDataDto> {
    return this.http
      .post<ApiEnvelope<PlatformAuthSuccessDataDto>>('/api/auth/refresh', { refreshToken })
      .pipe(map((envelope) => unwrapApiEnvelope(envelope)));
  }
}
